<tax-modal-header>{{ group.title }}</tax-modal-header>

<tax-modal-content>
  <div class="users" data-qa="users-count">
    {{ 'group.modal.delete.users' | translate }} {{ group.users?.length }}
  </div>
  <div class="text" translate data-qa="delete-notification">group.modal.delete.error</div>
</tax-modal-content>
